import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import { putRequest } from 'src/utils/request';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

import messages from '../../messages';

const updateTaxClass = async (params: {
  uuid: string;
  taxClassCode: string;
}) => {
  const { uuid, taxClassCode } = params;
  const payload = { payroll: { tax_class_code: taxClassCode } };

  return await putRequest(API.PUT.updateTaxClass(uuid), payload);
};

export const useUpdateCandidateTaxClass = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: updateTaxClass,
    onSuccess: (_, { uuid }) => {
      client.invalidateQueries({
        queryKey: [QUERY_KEYS.CANDIDATE_DETAILS, uuid],
      });
      handleSuccess(formatMessage(messages.taxClassSaved));
    },
    onError: handleError,
  });
};
